var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFileUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_58487",
    "data-name": "Group 58487",
    transform: "translate(-455 -188)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Iconly_Light-Outline_Paper",
    "data-name": "Iconly/Light-Outline/Paper",
    transform: "translate(451.999 186)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Paper",
    transform: "translate(3.001 2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Combined-Shape",
    d: "M10.976,0A.754.754,0,0,1,11.1.011h.137a.752.752,0,0,1,.541.23l5.065,5.277a.749.749,0,0,1,.209.519V15.2A4.617,4.617,0,0,1,12.6,19.865H4.476A4.586,4.586,0,0,1,0,15.4V4.491A4.6,4.6,0,0,1,4.571.012h6.278A.754.754,0,0,1,10.976,0Zm-.75,1.511H4.573a3.087,3.087,0,0,0-3.072,3V15.2A3.087,3.087,0,0,0,4.51,18.366h8.064a3.12,3.12,0,0,0,2.979-3.156V6.983h-2.01a3.332,3.332,0,0,1-3.318-3.325Zm.563,11.1a.75.75,0,1,1,0,1.5h-5.4a.75.75,0,1,1,0-1.5ZM8.744,8.856a.75.75,0,0,1,0,1.5H5.388a.75.75,0,0,1,0-1.5Zm2.982-6.5V3.659a1.828,1.828,0,0,0,1.82,1.825h1.186Z",
    transform: "translate(-0.001 0)",
    fill: "#1b2737",
    fillRule: "evenodd"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_58456",
    "data-name": "Group 58456"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_531",
    "data-name": "Ellipse 531",
    cx: 8,
    cy: 8,
    r: 8,
    transform: "translate(465 198)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse_531_-_Outline",
    "data-name": "Ellipse 531 - Outline",
    d: "M6,1a5,5,0,1,0,5,5A5.006,5.006,0,0,0,6,1M6,0A6,6,0,1,1,0,6,6,6,0,0,1,6,0Z",
    transform: "translate(467 200)",
    fill: "#1b2737"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_58455",
    "data-name": "Group 58455",
    transform: "translate(8.55 -27.95)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Line_795",
    "data-name": "Line 795",
    d: "M3.9.6H0A.6.6,0,0,1-.6,0,.6.6,0,0,1,0-.6H3.9a.6.6,0,0,1,.6.6A.6.6,0,0,1,3.9.6Z",
    transform: "translate(462.5 233.95)",
    fill: "#1b2737"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_796",
    "data-name": "Line 796",
    d: "M3.9.6H0A.6.6,0,0,1-.6,0,.6.6,0,0,1,0-.6H3.9a.6.6,0,0,1,.6.6A.6.6,0,0,1,3.9.6Z",
    transform: "translate(464.45 232) rotate(90)",
    fill: "#1b2737"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileUpload);
export default __webpack_public_path__ + "static/media/fileUpload.0f87feba6e9fb9819c2ba6465a55a21a.svg";
export { ForwardRef as ReactComponent };